module.exports = __webpack_public_path__ + "img/qr_watch_1000.a192ccde.png";